import React, { PureComponent } from 'react';
import { withCapoeiraSportState } from 'src/ver2/context';
import { Link } from 'react-router-dom';

import './style.css';

/**
  Баннерная плашка главной: две картинки в ряд — запись на тренировки и раздел «Музыка».
 */

class OwlQuestPlashka extends PureComponent {

    state = {
        loadingQuest: null
    }

    // constructor(props) {
    //     super(props);
    // }

    componentDidMount = async () => {
    }

    render() {

        const { upperStyle } = this.props;
        const { width, height } = upperStyle;

        // Две картинки в ряд (вместо одной all_groups_main.jpg): у каждой свой переход.
        // Файлы new__all_groups/new__music — ровно половинки прежнего баннера по ширине
        // при той же высоте (817px), поэтому в ряд они дают ту же высоту, что и одиночный.
        // Вёрстка — в style.css (.owl_quest_plashka_item): рамка + скругление 9px, прижаты к краям.
        return <div style={{ width, height }} className='owl_quest_plashka'>
            <Link to={'/all_groups'} className='owl_quest_plashka_item'>
                <img src="/../images/ver2/new__all_groups.jpg" />
            </Link>
            <Link to={'/music/'} className='owl_quest_plashka_item'>
                <img src="/../images/ver2/new__music.jpg" />
            </Link>
        </div>
    }

}

export default withCapoeiraSportState('client')(OwlQuestPlashka);